import {ErrorComponent} from '@refinedev/mui';
import {Route, Routes as RouterRoutes} from 'react-router';

import {Home} from '@pages/pilotage-rh';
import CreateAccount from '@pages/pilotage-rh/accounts/create-account';
import EditAccount from '@pages/pilotage-rh/accounts/edit-account';
import ListAccount from '@pages/pilotage-rh/accounts/list-account';
import {CreateIndicator} from '@pages/pilotage-rh/indicators/create-indicator';
import {EditIndicator} from '@pages/pilotage-rh/indicators/edit-indicator';
import ListIndicators from '@pages/pilotage-rh/indicators/list-indicators';
import CreateUser from '@pages/pilotage-rh/users/create-user';
import ListUsers from '@pages/pilotage-rh/users/list-users';

export const Routes = () => {
  return (
    <RouterRoutes>
      <Route index element={<Home />} />
      <Route path="accounts">
        <Route index element={<ListAccount />} />
        <Route path="create" element={<CreateAccount />} />
        <Route path="edit/:id" element={<EditAccount />} />
      </Route>
      <Route path="users">
        <Route index element={<ListUsers />} />
        <Route path="create" element={<CreateUser />} />
        {/*<Route path="edit/:id" element={<EditAccount />} />*/}
      </Route>
      <Route path="indicators">
        <Route index element={<ListIndicators />} />
        <Route path="create" element={<CreateIndicator />} />
        <Route path="edit/:id" element={<EditIndicator />} />
      </Route>
      <Route path="*" element={<ErrorComponent />} />
    </RouterRoutes>
  );
};
